export interface ErrorMapping {
  ftlId: string;
  vars?: Record<string, string | number>;
}

const bytesToWholeMB = (bytes: number): number =>
  Math.round(bytes / (1024 * 1024));

export const pickErrorMapping = (
  backendCode: string | undefined,
  maxSizeBytes: number
): ErrorMapping => {
  switch (backendCode) {
    case "file_too_large":
      return {
        ftlId: "receipts-upload-error-size",
        vars: { sizeMb: bytesToWholeMB(maxSizeBytes) },
      };
    case "unsupported_mime_type":
      return { ftlId: "receipts-upload-error-type" };
    case "corrupt_file":
      return { ftlId: "receipts-upload-error-integrity" };
    default:
      return { ftlId: "receipts-upload-error-generic" };
  }
};
